import { machine } from '@/statemachines/app.machine';
import { interpret } from 'xstate';
import { useInspector } from '@/statemachines/utils';
import { useInterpret } from '@xstate/vue';
import { store } from '@/statemachines/store';

type UseAppMachineOptions = {
  forceNew?: boolean;
};

export const resetAppMachine = () => {
  if (store.appService && typeof store.appService.stop === 'function') {
    store.appService.stop();
  }
  store.appService = undefined;
};

export const useAppMachine = (options: UseAppMachineOptions = {}) => {
  if (options.forceNew) {
    resetAppMachine();
  }
  if (!store.appService) {
    // machine is not instantiated - init
    if (import.meta.env.MODE === 'test') {
      const machineWithConfig = machine.withConfig({}, machine.context || {});
      store.appService = interpret(machineWithConfig, {
        devTools: useInspector(),
      }).start();
    } else {
      /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      store.appService = useInterpret(machine, {
        devTools: useInspector(),
      });
    }
  }
  return store.appService;
};
